module.exports = __webpack_public_path__ + "static/media/flexed-biceps-svgrepo-com.766f69f7.svg";